import { render, staticRenderFns } from "./plantilla.vue?vue&type=template&id=10537bcf&scoped=true&"
import script from "./plantilla.vue?vue&type=script&lang=js&"
export * from "./plantilla.vue?vue&type=script&lang=js&"
import style0 from "./plantilla.vue?vue&type=style&index=0&id=10537bcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10537bcf",
  null
  
)

export default component.exports